import React, { useContext, useEffect, useState } from 'react';
import Form from '../../components/form';
import mes from '../../enums/mes';
import api from '../../services/api';
import AppContext from '../../container/context';
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';
import ActionTable from '../../components/table/ActionTable';
import Dialog from '@mui/material/Dialog';
import { mergeParams } from '../../helpers/helpers';

export default function PainelControle({ history, location }) {
  const { notification } = useContext(AppContext);
  const [dataAtual] = useState(new Date());
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        escolaNomeFantasia: '',
        situacao: 0,
        mesInicio: new Date().getMonth() + 1,
        anoInicio: new Date().getFullYear(),
        mesFim: new Date().getMonth() + 1,
        anoFim: new Date().getFullYear(),
      },
      location,
    ),
  );
  const [carregando, setCarregando] = useState(false);
  const [escolasFaturas, setEscolasFaturas] = useState([]);
  const [faturaCancelar, setFaturaCancelar] = useState({});
  const [carregandoIUGU, setCarregandoIUGU] = useState(false);
  const [dadosIUGU, setDadosIUGU] = useState([]);
  const [pendentes, setPendentes] = useState('0');
  const [pagas, setPagas] = useState('0');
  const [canceladas, setCanceladas] = useState('0');
  const [expiradas, setexpiradas] = useState('0');

  useEffect(() => {
    listarEscolasFaturas();
  }, []);

  const listarEscolasFaturas = (filtrosEnviar = filtros) => {
    const faturasCarregar = {
      escolaNomeFantasia: filtrosEnviar.escolaNomeFantasia,
      situacao: filtrosEnviar.situacao,
      mesInicio: filtrosEnviar.mesInicio,
      anoInicio: filtrosEnviar.anoInicio,
      mesFim: filtrosEnviar.mesFim,
      anoFim: filtrosEnviar.anoFim,
    };

    setFiltros(faturasCarregar);
    setCarregando(true);

    api
      .get('faturas/painelControle', faturasCarregar)
      .then((escolasFaturasBase) => {
        escolasFaturasBase.forEach((ef) => {
          ef.valor = (ef.valor / 100).toFixed(2);
          ef.linkFatura = ef.faturaId ? (
            <>
              <a href={ef.faturaLinkIugu} target="_blank" rel="noreferrer">
                {ef.faturaLinkIugu}
              </a>
              {ef.faturaAvulsa ? (
                <p>(fatura avulsa)</p>
              ) : ef.faturaVisualizacoes ? (
                <p>(visualizações: {ef.faturaVisualizacoes})</p>
              ) : (
                <p>(não visualizada)</p>
              )}
            </>
          ) : (
            '(fatura não gerada)'
          );

          ef.vencimentoPagamentos = `${ef.vencimentoMes}/${ef.vencimentoAno}`;

          if (ef.faturaId) {
            ef.vencimento = ef.faturaId
              ? new Date(ef.faturaVencimento).toLocaleDateString('pt-BR')
              : 'Fatura não gerada';

            if (ef.faturaPagamento) {
              ef.pagamento = `Ok (${new Date(
                ef.faturaPagamento,
              ).toLocaleDateString('pt-BR')})`;
              ef.customStyle = { backgroundColor: '#99ff9e' };
            } else {
              if (new Date(ef.faturaVencimento) >= dataAtual) {
                ef.pagamento = `Não registrado`;
              } else {
                ef.pagamento = `Não registrado (vencido)`;
                ef.customStyle = { backgroundColor: '#fcb49a' };
              }
            }
          } else {
            ef.vencimento = 'Fatura não gerada';
          }

          ef.acoes = (
            <>
              <IconButton
                key={0}
                title={'Visualizar'}
                style={{ color: 'black' }}
                onClick={() => {
                  history.push(
                    `/app/faturas/fatura-escola/${ef.escolaId}/${ef.vencimentoAno}/${ef.vencimentoMes}`,
                  );
                }}
              >
                <i className="zmdi zmdi-collection-text"></i>
              </IconButton>
              {ef.faturaId ? (
                !ef.faturaPagamento && (
                  <>
                    <IconButton
                      key={0}
                      title={'Sincronizar com IUGU'}
                      style={{ color: 'darkgreen' }}
                      onClick={() => sincronizarIugu(ef, escolasFaturasBase)}
                    >
                      <i className="zmdi zmdi-refresh-sync"></i>
                    </IconButton>
                    <IconButton
                      key={1}
                      title={'Cancelar'}
                      style={{ color: 'red' }}
                      onClick={() => setFaturaCancelar(ef)}
                    >
                      <i className="zmdi zmdi-smartphone-erase"></i>
                    </IconButton>
                  </>
                )
              ) : (
                <IconButton
                  key={0}
                  title={'Gerar fatura'}
                  style={{ color: 'blue' }}
                  onClick={() => gerarFatura(ef)}
                >
                  <i className="zmdi zmdi-smartphone-download"></i>
                </IconButton>
              )}
            </>
          );
        });

        setEscolasFaturas(escolasFaturasBase);
        setCarregando(false);
      })
      .catch((err) => {
        notification('error', 'Erro ao listar as faturas.');
      });
  };

  const sincronizarIugu = (faturaEscola, escolas) => {
    let acoes;

    let escolasFaturasAtualizar = [...escolas];
    escolasFaturasAtualizar
      .filter((efa) => efa.escolaId === faturaEscola.escolaId)
      .forEach((efa) => {
        acoes = { ...efa.acoes };
        efa.acoes = <CircularProgress />;
      });

    setEscolasFaturas(escolasFaturasAtualizar);

    api
      .post('faturas/sincronizarIugu', { faturaId: faturaEscola.faturaId })
      .then((res) => {
        switch (res.status) {
          case 1:
            notification('warning', 'Pagamento pendente.');

            break;
          case 2:
            notification('success', 'Pagamento confirmado!');

            return listarEscolasFaturas(filtros);
          case 3:
            notification('warning', 'Fatura cancelada.');

            break;
          case 4:
            notification('warning', 'Fatura suspensa.');

            break;
          default:
            notification('warning', 'Fatura suspensa.');
        }

        escolasFaturasAtualizar
          .filter((efa) => efa.escolaId === faturaEscola.escolaId)
          .forEach((efa) => {
            efa.acoes = acoes;
            efa.linkFatura = (
              <>
                <a href={efa.faturaLinkIugu} target="_blank" rel="noreferrer">
                  {efa.faturaLinkIugu}
                </a>
                {res.visualizacoes ? (
                  <p>(Visualizações: {res.visualizacoes})</p>
                ) : (
                  <p>(Não visualizada)</p>
                )}
              </>
            );
          });

        return setEscolasFaturas(escolasFaturasAtualizar);
      })
      .catch((e) => {
        console.log(e);
        notification('error', 'Erro ao cancelar a fatura.');
      });
  };

  const sincronizarIUGU = () => {
    setCarregandoIUGU(true);
    api
      .post('faturas/sincronizarIuguPendentes')
      .then((res) => {
        setDadosIUGU(res);

        const faturasPagas = res.filter((r) => r.paga === true);
        const faturasPendentes = res.filter((r) => r.pendente === true);
        const faturasCanceladas = res.filter((r) => r.cancelada === true);
        const faturasExpiradas = res.filter((r) => r.expirada === true);

        if (faturasPagas.length > 0) {
          setPagas(faturasPagas.length);
        }
        if (faturasPendentes.length > 0) {
          setPendentes(faturasPendentes.length);
        }
        if (faturasCanceladas.length > 0) {
          setCanceladas(faturasCanceladas.length);
        }
        if (faturasExpiradas.length > 0) {
          setexpiradas(faturasExpiradas.length);
        }

        setCarregandoIUGU(false);
      })
      .catch((e) => {
        console.log(e);
        notification('error', 'Erro ao sincronizar pendentes');
        setCarregandoIUGU(false);
      });
  };

  const fFiltros = {
    title: 'Filtros',
    form: {
      escolaNomeFantasia: {
        label: 'Escola',
        type: 'text',
        value: filtros.escolaNomeFantasia,
        space: 6,
      },
      situacao: {
        label: 'Situação',
        type: 'select',
        value: filtros.situacao,
        space: 6,
        emptyItem: true,
        emptyItemText: '(Todas)',
        options: [
          {
            value: 1,
            desc: 'Não pagas',
          },
          {
            value: 2,
            desc: 'Vencidas',
          },
          {
            value: 3,
            desc: 'Pagas',
          },
        ],
      },
      mesInicio: {
        label: 'Mês (a partir de)',
        type: 'select',
        emptyItem: true,
        space: 3,
        array: {
          data: meses,
          value: 'id',
          desc: 'nome',
        },
        value: filtros.mesInicio,
      },
      anoInicio: {
        label: 'Ano (a partir de)',
        type: 'select',
        value: filtros.anoInicio,
        space: 3,
        options: (() => {
          const anos = [];

          for (
            var i = dataAtual.getFullYear() - 3;
            i <= dataAtual.getFullYear();
            i++
          ) {
            anos.push({ value: i, desc: i.toString() });
          }

          return anos;
        })(),
      },
      mesFim: {
        label: 'Mês (até)',
        type: 'select',
        emptyItem: true,
        space: 3,
        array: {
          data: meses,
          value: 'id',
          desc: 'nome',
        },
        value: filtros.mesFim,
      },
      anoFim: {
        label: 'Ano (até)',
        type: 'select',
        value: filtros.anoFim,
        space: 3,
        options: (() => {
          const anos = [];

          for (
            var i = dataAtual.getFullYear() - 3;
            i <= dataAtual.getFullYear();
            i++
          ) {
            anos.push({ value: i, desc: i.toString() });
          }

          return anos;
        })(),
      }
    },
    submit: {
      label: 'Listar',
      action: listarEscolasFaturas,
    },
    customActions: [
      {
        label: 'Sincronizar (IUGU) pendentes',
        action: () => sincronizarIUGU(),
      },
    ],

    urlParams: true,
    history,
    location,
  };

  const tEscolasFaturas = {
    title: 'Escolas/faturas',
    array: escolasFaturas,
    columns: [
      {
        name: 'escolaNomeFantasia',
        label: 'Escola',
      },
      {
        name: 'valor',
        label: 'Valor R$',
      },
      {
        name: 'linkFatura',
        label: 'Fatura Iugu',
      },
      {
        name: 'vencimentoPagamentos',
        label: 'Vencimento (ref. pagamentos)',
      },
      {
        name: 'vencimento',
        label: 'Vencimento (fatura gerada)',
      },
      {
        name: 'pagamento',
        label: 'Pagamento',
      },
      {
        name: 'acoes',
        label: 'Ações',
      },
    ],
  };

  const cancelarFatura = () => {
    api
      .post('faturas/cancelar', { faturaId: faturaCancelar.faturaId })
      .then(() => {
        notification('warning', 'Fatura cancelada.');
        listarEscolasFaturas(filtros);
        setFaturaCancelar({});
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification('error', 'Já cancelada');
          case 2:
            return notification('error', 'Fatura paga');
          default:
            return notification('error', 'Dados inválidos');
        }
      });
  };

  const gerarFatura = (escolaFatura) => {
    const dadosFatura = {
      escolaId: escolaFatura.escolaId,
      mes: escolaFatura.vencimentoMes,
      ano: escolaFatura.vencimentoAno,
    };

    api
      .put('faturas/faturar', dadosFatura)
      .then((faturaGerada) => {
        notification('success', 'Fatura gerada com sucesso!');
        listarEscolasFaturas(filtros);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification('error', 'Período inválido');
          case 2:
            return notification('error', 'Sem pagamentos para faturar');
          case 3:
            return notification(
              'error',
              'Já existe fatura ativa para o período',
            );
          default:
            return notification('error', 'Dados inválidos');
        }
      });
  };

  const fIuguPendentes = {
    title: 'Faturas sincronizadas',
    form: {
      total: {
        label: 'Total',
        type: 'text',
        space: 3,
        readOnly: true,
        value: dadosIUGU.length,
      },
      pagas: {
        label: 'Pagas',
        type: 'text',
        space: 3,
        readOnly: true,
        value: pagas,
      },
      pendentes: {
        label: 'Pendentes',
        type: 'text',
        space: 2,
        readOnly: true,
        value: pendentes,
      },
      canceladas: {
        label: 'Canceladas',
        type: 'text',
        space: 2,
        readOnly: true,
        value: canceladas,
      },
      expiradas: {
        label: 'Expiradas',
        type: 'text',
        space: 2,
        readOnly: true,
        value: expiradas,
      },
    },
  };

  return (
    <div>
      <Form formData={fFiltros} />

      {carregandoIUGU ? (
        <div style={{ backgroundColor: 'white', padding: 10 }}>
          <h4>Sincronizar faturas</h4>
          <div style={{ textAlign: 'center' }}>
            <CircularProgress />

            <h4>
              Sincronizando faturas pendentes com a Iugu. Dependendo da
              quantidade de faturas em aberto, este processo pode demorar alguns
              minutos.
            </h4>
          </div>
        </div>
      ) : (
        <>{dadosIUGU.length > 0 && <Form formData={fIuguPendentes} />}</>
      )}

      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tEscolasFaturas} />
      )}

      <Dialog
        open={faturaCancelar.faturaId}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Cancelar fatura</DialogTitle>
        <DialogContent>
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            Deseja realmente cancelar a fatura gerada para a escola{' '}
            {faturaCancelar.escolaNomeFantasia}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => cancelarFatura()}
          >
            Cancelar fatura
          </Button>
          <Button variant="contained" onClick={() => setFaturaCancelar({})}>
            voltar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const meses = [
  { id: '1', nome: 'Janeiro' },
  { id: '2', nome: 'Fevereiro' },
  { id: '3', nome: 'Março' },
  { id: '4', nome: 'Abril' },
  { id: '5', nome: 'Maio' },
  { id: '6', nome: 'Junho' },
  { id: '7', nome: 'Julho' },
  { id: '8', nome: 'Agosto' },
  { id: '9', nome: 'Setembro' },
  { id: '10', nome: 'Outubro' },
  { id: '11', nome: 'Novembro' },
  { id: '12', nome: 'Dezembro' },
];
